import React from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import api from '../../utils/axios.ts';

export interface MemberOption {
  value: number;
  label: string;
  rawMember?: any;
}

interface AsyncMemberSelectProps {
  value: MemberOption | null;
  onChange: (value: MemberOption | null) => void;
  isClearable?: boolean;
  placeholder?: string;
  className?: string;
  classNamePrefix?: string;
  id?: string;
  required?: boolean;
  isDisabled?: boolean;
  unassignedOnly?: boolean;
}

export default function AsyncMemberSelect(props: AsyncMemberSelectProps) {
  const loadOptions = async (search: string, loadedOptions: any, { page }: { page: number }) => {
    try {
      const response = await api.get('/members', {
        params: {
          search,
          page,
          per_page: 50,
          subgroup_id: props.unassignedOnly ? 'none' : undefined,
        },
      });

      // Laravel standard pagination format
      const data = response.data?.data || [];
      const meta = response.data?.meta;
      
      const hasMore = meta ? page < meta.last_page : false;

      return {
        options: data.map((member: any) => ({
          value: member.id,
          label: `${member.name} (${member.phone_number})`,
          rawMember: member,
        })),
        hasMore,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      console.error('Failed to load members:', error);
      return {
        options: [],
        hasMore: false,
      };
    }
  };

  return (
    <AsyncPaginate
      {...props}
      classNamePrefix={props.classNamePrefix || "select"}
      loadOptions={loadOptions}
      additional={{ page: 1 }}
      debounceTimeout={300}
    />
  );
}
